<div class="card">
  <h5 class="card-header height_60">
    <span class="title font_size_22">
      Floating Data Cost Control
    </span>

    <div>
      <button class="btn btn-primary-soft float_right_margin10" (click)="refresh(true)">
        <i class="fa fa-refresh" aria-hidden="true"></i>
        Refresh
      </button>
      <button class="btn btn-success-soft float_right_margin10" (click)="createScan(true)">
        <i class="fa fa-search" aria-hidden="true"></i>
        Scan
      </button>
    </div>
  </h5>
  <div class="card-body">
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          class="nav-link active"
          data-bs-toggle="tab"
          data-bs-target="#floating-data-scan"
          type="button"
          role="tab"
          aria-controls="floating-data-scan"
          aria-selected="true"
          (click)="currentPage = 'scan'"
        >
          Scan
        </a>
        <a
          class="nav-link"
          data-bs-toggle="tab"
          data-bs-target="#floating-data-images"
          type="button"
          role="tab"
          aria-controls="floating-data-images"
          aria-selected="false"
          (click)="currentPage = 'floating_images'"
        >
          Floating Images
        </a>
        <a
          class="nav-link"
          data-bs-toggle="tab"
          data-bs-target="#floating-data-snapshots"
          type="button"
          role="tab"
          aria-controls="floating-data-snapshots"
          aria-selected="false"
          (click)="currentPage = 'floating_disk_snapshots'"
        >
          Floating Snapshots
        </a>
        <a
          class="nav-link"
          data-bs-toggle="tab"
          data-bs-target="#floating-data-disks"
          type="button"
          role="tab"
          aria-controls="floating-data-disks"
          aria-selected="false"
          (click)="currentPage = 'unattached_managed_disks'"
        >
          Unattached Managed Disks
        </a>
      </div>
    </nav>

    <div class="tab-content" id="nav-tabContent">
      <div class="tab-pane active" id="floating-data-scan" role="tabpanel">
        <div class="card">
          <div class="card-body">
            <table class="table table-docs table-hover">
              <thead>
                <tr>
                  <th>S.N.</th>
                  <th *ngFor="let h of scanHeaders">{{ h.name }}</th>
                </tr>
              </thead>

              <tbody *ngIf="jobDetails">
                <tr>
                  <td>1</td>
                  <td *ngFor="let h of scanHeaders">
                    {{ getCellValue(scanInfo, h.id) }}
                  </td>
                </tr>
              </tbody>
              <tbody *ngIf="!jobDetails">
                <tr>
                  <td [attr.colspan]="scanHeaders.length + 1">
                    <div class="center" *ngIf="!loading">
                      No Scans Found. <span class="nav-link" (click)="createScan()">Click here</span> to create one
                    </div>
                    <div class="center" *ngIf="loading">
                      <img src="../assets/img/loading_2.svg" alt="loading scans" class="width_15" />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="tab-pane" id="floating-data-images" role="tabpanel">
        <div class="card">
          <div class="card-body">
            <div *ngIf="loading" class="alert alert-info floating_reports_download_container" role="alert">
              <span>Loading latest scan details...</span>
              <span>
                <img src="../assets/img/loading_2.svg" alt="loading scans" class="width_15" />
              </span>
            </div>
            <div *ngIf="!loading && isScanCompleted()" class="alert alert-success floating_reports_download_container" role="alert">
              <span *ngIf="hasArtifact('floating_images')">Floating Images report is ready to download</span>
              <span *ngIf="!hasArtifact('floating_images')">Floating Images report not found</span>
              <span *ngIf="hasArtifact('floating_images')">
                <button class="btn btn-success" (click)="downloadArtifact('floating_images')">Download</button>
              </span>
            </div>
            <div *ngIf="!loading && isScanRunning()" class="alert alert-info floating_reports_download_container" role="alert">
              <span>Floating Images report is not ready. Please wait.</span>
              <span>
                <button class="btn btn-info" (click)="refresh(true)">Refresh</button>
              </span>
            </div>
            <div *ngIf="!jobDetails && !loading" class="alert alert-info floating_reports_download_container" role="alert">
              <span>No Scans Found</span>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-pane" id="floating-data-snapshots" role="tabpanel">
        <div class="card">
          <div class="card-body">
            <div *ngIf="loading" class="alert alert-info floating_reports_download_container" role="alert">
              <span>Loading latest scan details...</span>
              <span>
                <img src="../assets/img/loading_2.svg" alt="loading scans" class="width_15" />
              </span>
            </div>
            <div *ngIf="!loading && isScanCompleted()" class="alert alert-success floating_reports_download_container" role="alert">
              <span *ngIf="hasArtifact('floating_disk_snapshots')">Floating Snapshots report is ready to download</span>
              <span *ngIf="!hasArtifact('floating_disk_snapshots')">Floating Snapshots report not found</span>
              <span *ngIf="hasArtifact('floating_disk_snapshots')">
                <button class="btn btn-success" (click)="downloadArtifact('floating_disk_snapshots')">Download</button>
              </span>
            </div>
            <div *ngIf="!loading && isScanRunning()" class="alert alert-info floating_reports_download_container" role="alert">
              <span>Floating Snapshots report is not ready. Please wait.</span>
              <span>
                <button class="btn btn-info" (click)="refresh(true)">Refresh</button>
              </span>
            </div>
            <div *ngIf="!jobDetails && !loading" class="alert alert-info floating_reports_download_container" role="alert">
              <span>No Scans Found</span>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-pane" id="floating-data-disks" role="tabpanel">
        <div class="card">
          <div class="card-body">
            <div *ngIf="loading" class="alert alert-info floating_reports_download_container" role="alert">
              <span>Loading latest scan details...</span>
              <span>
                <img src="../assets/img/loading_2.svg" alt="loading scans" class="width_15" />
              </span>
            </div>
            <div *ngIf="!loading && isScanCompleted()" class="alert alert-success floating_reports_download_container" role="alert">
              <span *ngIf="hasArtifact('unattached_managed_disks')">
                Unattached Managed Disks report is ready to download
              </span>
              <span *ngIf="!hasArtifact('unattached_managed_disks')">Unattached Managed Disks report not found</span>
              <span *ngIf="hasArtifact('unattached_managed_disks')">
                <button class="btn btn-success" (click)="downloadArtifact('unattached_managed_disks')">Download</button>
              </span>
            </div>
            <div *ngIf="!loading && isScanRunning()" class="alert alert-info floating_reports_download_container" role="alert">
              <span>Unattached Managed Disks report is not ready. Please wait.</span>
              <span>
                <button class="btn btn-info" (click)="refresh(true)">Refresh</button>
              </span>
            </div>
            <div *ngIf="!jobDetails && !loading" class="alert alert-info floating_reports_download_container" role="alert">
              <span>No Scans Found</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
